import React from 'react';
import { Link } from 'react-router-dom';

var updateData = {
   "27": {
      "id": "27",
      "filter": "site",
      "date": "",
      "subtitle": "<b>About RPGONE Translations</b><br />",
      "content": [
	{
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <Link to='about'>About RPGONE Translations page</Link>
               }
            ]
         }, 
	 {
            "label": "text",
            "value": "<br /><br />The About RPGONE Translations page is here, showing all projects that we have worked on.<br /><br />"
         },
         {
            "label": "img",
            "value": [
 	       {
                  "label": "0",
                  "value": <img src={ require('./img/banner.gif')} alt='' className='imageResize'/>
               }
	    ]
	 },
      ]
   },
   "26": {
      "id": "26",
      "filter": "mickey3",
      "date": "28 January 2021",
      "subtitle": "<b>Magical Quest 3 starring Mickey & Donald</b> v1.0 Swedish Release<br />",
      "content": [
         {
            "label": "text",
            "value": "<b>Download Magical Quest 3 Swedish Translation patch v1.0 ",
	},
	{
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <span><a href="https://www.romhacking.net/translations/5907/">HERE</a><br /></span>
               }
            ]
         },
 	 {
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <Link to='mickey3'>Magical Quest 3 project page</Link>
               }
            ]
         }, 
 	 {
            "label": "text",
            "value": "<br /><br />Mattiac has recently completed a full translation of Magical Quest 3 to Swedish. A few new hacks were necessary such as adding accents to the large Stage Name text. I've fully played through this translation and he has done a great job. Just wish I could understand more of the Swedish Viking language. Nice working with you!<br /><br />",
         },
	 {
            "label": "img",
            "value": [
 	       {
                  "label": "0",
                  "value": <img src={ require('./img/mickey3_swedish_1.png')} alt='' className='imageResize'/>
               },
	       {
                  "label": "1",
                  "value": <img src={ require('./img/mickey3_swedish_2.png')} alt='' className='imageResize'/>
               },
	       {
                  "label": "1",
                  "value": <img src={ require('./img/mickey3_swedish_3.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "1",
                  "value": <img src={ require('./img/mickey3_swedish_4.png')} alt='' className='imageResize'/>
               },
	    ]
	 },
      ]
   },
   "25": {
      "id": "25",
      "filter": "mickey3",
      "date": "18 June 2020",
      "subtitle": "<b>Magical Quest 3 starring Mickey & Donald</b> v1.5 English, v1.4 Spanish & v1.0 Portuguese Release<br />",
      "content": [
         {
            "label": "text",
            "value": "<b>Download Magical Quest 3 English Translation patch v1.5 ",
	},
	{
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <span><a href={ require('./files/Magical Quest 3 - English v1.5.zip')} download='Magical Quest 3 - English v1.5.zip'>HERE</a><br /></span>
               }
            ]
         },
	 {
            "label": "text",
            "value": "<b>Download Magical Quest 3 Spanish Translation patch v1.4 ",
	},
	{
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <span><a href="https://traduccionessemco.blogspot.com/2018/12/traduccion-magical-quest-3-starring.html">HERE</a><br /></span>
               }
            ]
         },
	 {
            "label": "text",
            "value": "<b>Download Magical Quest 3 Portuguese Translation patch v1.0 ",
	},
	{
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <span><a href={ require('./files/Magical Quest 3 - Portuguese v1.0.zip')} download='Magical Quest 3 - Portuguese v1.0.zip'>HERE</a><br /></span>
               }
            ]
         },
 	 {
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <Link to='mickey3'>Magical Quest 3 project page</Link>
               }
            ]
         }, 
 	 {
            "label": "text",
            "value": "<br /><br /><div class='center-image'><b>Magical Quest 3 English Translation v1.5</b></div>This update most importantly features a new title logo which is much more in keeping with the English Magical Quest series logo, and is something I have always wanted to do.  Thanks to blade133bo for his work on the Spanish Magical Quest 1 logo, which was partly used in the new Spanish and Portuguese title logos.<br /><br />The colors of the title logo were changed, and this meant that the 30 fade in palettes for the title logo also needed to be changed which was a lot of work by itself.<br /><br />",
         },
         {
            "label": "img",
            "value": [
 	       {
                  "label": "0",
                  "value": <img src={ require('./img/mickey3_english_1.gif')} alt='' className='imageResize'/>
               }
	    ]
	 },
	 {
            "label": "text",
            "value": "<br />This release also fixes a few small issues, such as Donald's magic costume icon which was slightly corrupted on stage 5-3 and this bug was found once again thanks to Goro's Lair.<br /><br />",
	 },
	 {
            "label": "img",
            "value": [
 	       {
                  "label": "0",
                  "value": <img src={ require('./img/mickey3_english_1.png')} alt='' className='imageResize'/>
               },
	       {
                  "label": "1",
                  "value": <img src={ require('./img/mickey3_english_2.png')} alt='' className='imageResize'/>
               },
	    ]
	 },
	 {
            "label": "text",
            "value": "<br /><br /><div class='center-image'><b>Magical Quest 3 (Aventura Mágica 3 Protagonizado por Mickey & Donald) Spanish Translation v1.5</b></div>The Spanish version has been updated with the new title logo and various improvements and bugfixes. The Options screen and General Store title graphics have now also been translated.<br /><br />",
	 },
	 {
            "label": "img",
            "value": [
 	       {
                  "label": "0",
                  "value": <img src={ require('./img/mickey3_spanish_1.png')} alt='' className='imageResize'/>
               },
	       {
                  "label": "1",
                  "value": <img src={ require('./img/proj/mickey_esp_3000.png')} alt='' className='imageResize'/>
               },
	       {
                  "label": "2",
                  "value": <img src={ require('./img/mickey3_spanish_3.png')} alt='' className='imageResize'/>
               },
	       {
                  "label": "3",
                  "value": <img src={ require('./img/mickey3_spanish_4.png')} alt='' className='imageResize'/>
               },
	    ]
	 },
         {
            "label": "text",
            "value": "<br /><br /><div class='center-image'><b>Magical Quest 3 (Aventura Mágica 3 Estrelando Mickey & Donald) Portuguese Translation - Initial release v1.0</b></div>A Portuguese Translation has now been completed by Goro's Lair. It features accents for all text which has been fully translated to Portuguese. Congratulations to Goro's Lair for completing his first translation project and also many thanks for his assistance in testing the English version.<br /><br />",
	 },
	 {
            "label": "img",
            "value": [
 	       {
                  "label": "0",
                  "value": <img src={ require('./img/mickey3_portuguese_1.png')} alt='' className='imageResize'/>
               },
	       {
                  "label": "1",
                  "value": <img src={ require('./img/mickey3_portuguese_2.png')} alt='' className='imageResize'/>
               },
	       {
                  "label": "2",
                  "value": <img src={ require('./img/mickey3_portuguese_3.png')} alt='' className='imageResize'/>
               },
	       {
                  "label": "3",
                  "value": <img src={ require('./img/mickey3_portuguese_4.png')} alt='' className='imageResize'/>
               },
	       {
                  "label": "4",
                  "value": <img src={ require('./img/mickey3_portuguese_5.png')} alt='' className='imageResize'/>
               },
	       {
                  "label": "4",
                  "value": <img src={ require('./img/mickey3_portuguese_6.png')} alt='' className='imageResize'/>
               },
		    ]
	},
      ]
   },
   "24": {
      "id": "24",
      "filter": "mickey3",
      "date": "18 June 2020",
      "subtitle": "<b>Magical Quest 3 starring Mickey & Donald</b> - No Letterbox Hack Release<br />",
      "content": [
         {
            "label": "text",
            "value": "<b>Download Magical Quest 3 - No Letterbox hack ",
	},
	{
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <span><a href={ require('./files/Magical Quest 3 - No Letterbox hack.zip')} download='Magical Quest 3 - No Letterbox hack.zip'>HERE</a><br /></span>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br />The letterbox is the black border drawn at the top and bottom of the screen. It was added by the developer to allow more processes to be carried out without slowdown.<br /><br />The first Magical Quest game in the series didn't have a letterbox, and it looks much better not having a black border covering parts of the stage. The letterbox is primarily required when Mode-7 is being used such as for Bosses.  Mode-7 is used for a number of boss characters instead of sprites, eg Stage 1-4 Flying Pig boss, or Stage 2-5 Spider boss, which allows for full rotation of the boss.<br/><br />Each part of the status bar needed to have it's position moved for this hack, and to determine it's new position based on whether the letterbox is enabled or not. In this hack, the letterbox is still enabled during 5 of the boss fights that use Mode-7 as otherwise the boss or background will not appear.<br /><br />The letterbox is still enabled on the following stages:<br /><b>Stage 1-4 Flying Pig boss, Stage 2-5 Spider boss, Stage 3-4 Snake boss, Stage 4-1, Stage 4-4 Pirate boss, Stage 5-3 Octopus boss</b><br /><br /><div class='center-image'><b>Left is before with letterbox, right is without letterbox</b></div>",
	},
	{
            "label": "img",
            "value": [
	       {
                  "label": "0",
                  "value": <img src={ require('./img/mickey3_letterbox1.png')} alt='' className='imageResize'/>
               },
	       {
                  "label": "1",
                  "value": <img src={ require('./img/mickey3_no_letterbox1.png')} alt='' className='imageResize'/>
               },
		    ]
	},
	{
            "label": "img",
            "value": [
	       {
                  "label": "0",
                  "value": <img src={ require('./img/mickey3_letterbox2.png')} alt='' className='imageResize'/>
               },
	       {
                  "label": "1",
                  "value": <img src={ require('./img/mickey3_no_letterbox2.png')} alt='' className='imageResize'/>
               },
	             ]
	 },
      ]
   },
   "23": {
      "id": "23",
      "filter": "doremi",
      "date": "19 September 2019",
      "subtitle": "<b>DoReMi Fantasy : Milon's Quest</b> v1.3 English & German Releases<br />",
      "content": [
         {
            "label": "text",
            "value": "<b>Download DoReMi Fantasy English Translation patch v1.3 with New Ending ",
	},
	{
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <span><a href={ require('./files/Doremi Fantasy - English v1.3.zip')} download='Doremi Fantasy - English v1.3.zip'>HERE</a><br /></span>
               }
            ]
         },
         {
            "label": "text",
            "value": "<b>Download DoReMi Fantasy German Translation patch v1.3 with New Ending ",
	},
	{
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <span><a href={ require('./files/Doremi Fantasy - Deutsch v1.3.zip')} download='Doremi Fantasy - Deutsch v1.3.zip'>HERE</a><br /></span>
               }
            ]
         },
	 {
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <Link to='doremi'>DoReMi Fantasy project page</Link>
               }
            ]
         }, 
	 {
            "label": "text",
            "value": "<br /><br />This v1.3 English release fixes a potential crashing bug in the New Ending.<br /><br />"
         },
	 {
            "label": "img",
            "value": [
	       {
                  "label": "0",
                  "value": <img src={ require('./img/doremi_e4.gif')} alt='' className='imageResize'/>
               },
	             ]
	 },
 	 {
            "label": "text",
            "value": "<br />The German translation now also includes the New Ending sequence.  Thanks goes to Ice Man for translating the script of the New Ending to German.<br /><br />"
         },
	 {
            "label": "img",
            "value": [
	       {
                  "label": "0",
                  "value": <img src={ require('./img/doremi_de_1.png')} alt='' className='imageResize'/>
               },
	       {
                  "label": "1",
                  "value": <img src={ require('./img/doremi_de_2.png')} alt='' className='imageResize'/>
               },
	             ]
	 },
      ]
   },
   "22": {
      "id": "22",
      "filter": "mickey3",
      "date": "29 April 2019",
      "subtitle": "<b>Magical Quest 3 starring Mickey & Donald</b> v1.4 English Bugfix Release<br />",
      "content": [
         {
            "label": "text",
            "value": "<b>Download Magical Quest 3 English Translation patch v1.4 ",
	},
	{
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <span><a href={ require('./files/Magical Quest 3 - English v1.5.zip')} download='Magical Quest 3 - English v1.5.zip'>HERE</a><br /></span>
               }
            ]
         },
	 {
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <Link to='mickey3'>Magical Quest 3 project page</Link>
               }
            ]
         }, 
	 {
            "label": "text",
            "value": "<br /><br />This v1.4 release fixes a bug where the PAUSE text was not displayed when playing a 1-player game using Controller 2.  This was found thanks to Goro's Lair.<br /><br />"
         },
	 {
            "label": "img",
            "value": [
	       {
                  "label": "0",
                  "value": <img src={ require('./img/mickey3_pause.png')} alt='' className='imageResize'/>
               },
	             ]
	 },
      ]
   },
   "21": {
      "id": "21",
      "filter": "site",
      "date": "25 April 2019",
      "subtitle": "<b>Debug Modes section moved</b><br />",
      "content": [
	{
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <Link to='debug'>Debug Modes page</Link>
               }
            ]
         }, 
	 {
            "label": "text",
            "value": "<br /><br />The debug modes section has been relocated and shows some of the debug modes that were found while working on translation projects.<br /><br />"
         },
	 {
            "label": "img",
            "value": [
	       {
                  "label": "0",
                  "value": <img src={ require('./img/debug/mickey3e_00001.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "1",
                  "value": <img src={ require('./img/debug/Illusion_of_Gaia_Debug_001.png')} alt='' className='imageResize'/>
               },
	             ]
	 },
      ]
   },
   "20": {
      "id": "20",
      "filter": "mickey3",
      "date": "21 March 2019",
      "subtitle": "<b>Magical Quest 3 starring Mickey & Donald</b> v1.3 English Bugfix Release<br />",
      "content": [
         {
            "label": "text",
            "value": "<b>Download Magical Quest 3 English Translation patch v1.3 ",
	},
	{
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <span><a href={ require('./files/Magical Quest 3 - English v1.5.zip')} download='Magical Quest 3 - English v1.5.zip'>HERE</a><br /></span>
               }
            ]
         },
	 {
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <Link to='mickey3'>Magical Quest 3 project page</Link>
               }
            ]
         }, 
	 {
            "label": "text",
            "value": "<br /><br />This v1.3 release fixes a bug with the bonus game options text during 2-player co-op.  Thanks to Goro's Lair for reporting this.<br /><br />"
         },
	 {
            "label": "img",
            "value": [
	       {
                  "label": "0",
                  "value": <img src={ require('./img/mickey3e_00005_bonus.png')} alt='' className='imageResize'/>
               },
	             ]
	 },
      ]
   },
   "19": {
      "id": "19",
      "filter": "mickey",
      "date": "6 March 2019",
      "subtitle": "<b>The Magical Quest starring Mickey Mouse</b> v1.0 Spanish Translation Release<br />",
      "content": [
	 {
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <a href='https://www.romhacking.net/translations/4294/'>Download The Magical Quest Spanish translation on romhacking.net</a>
               }
            ]
         }, 
	 {
            "label": "text",
            "value": "<br /><br /><i>Mickey Mouse, Pluto, Goofy and Donald Duck are playing catch in the park. When it is Goofy's turn, he accidentally throws the ball too far. Pluto runs off chasing the ball and disappears. But his pal Mickey is hot on his trail! Pluto's tracks lead Mickey to a magical world filled with giant vines and strange new creatures. However, a dark shadow of mystery surrounds this land and it is not as peaceful as it seems.<br /><br />As he travels through the land, Mickey meets a kind, old wizard who tells him that evil Emperor Pete has snatched poor Pluto! Summoning his courage, Mickey vows to free his pal and sets off toward Emperor Pete's Castle. But it won't be easy for brave, little Mickey. Emperor Pete has cast a dark and sinister spell over his entire kingdom. And now, everyone in the land is after Mickey!</i><br /><br />Blade133bo has just finished a full Spanish translation of The Magical Quest. It's one of my favorite Snes games and was a lot of fun to work on.<br /><br />"
         },
	 {
            "label": "img",
            "value": [
	       {
                  "label": "0",
                  "value": <img src={ require('./img/MagicalQuestSpanish1.png')} alt='' className='imageResize'/>
               },
	       {
                  "label": "1",
                  "value": <img src={ require('./img/MagicalQuestSpanish2.png')} alt='' className='imageResize'/>
               },
	       {
                  "label": "2",
                  "value": <img src={ require('./img/MagicalQuestSpanish3.png')} alt='' className='imageResize'/>
               },
	       {
                  "label": "3",
                  "value": <img src={ require('./img/MagicalQuestSpanish4.png')} alt='' className='imageResize'/>
               },
	             ]
	 },
      ]
   },
   "18": {
      "id": "18",
      "filter": "miracle",
      "date": "10 February 2019",
      "subtitle": "<b>Miracle Girls</b> v1.1 English Release<br />",
      "content": [
         {
            "label": "text",
            "value": "<b>Download Miracle Girls English Translation patch v1.1 ",
	},
	{
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <span><a href={ require('./files/Miracle Girls - English v1.1.zip')} download='Miracle Girls - English v1.1.zip'>HERE</a><br /></span>
               }
            ]
         },
	 {
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <Link to='miracle'>Miracle Girls project page</Link>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br /><br />The main point of this update was to insert the standard English Miracle Girls logo for the title logo. I always wanted to add this logo, but it's a large amount of work to insert for this game due to the animated sequence that uses 16 separate palettes that all needed updating, 2 versions of the logo and a few tilemaps. It took 3 days work in total.<br /><br />Various other graphics have been updated including the demo game mini-logo, the Miracle Station bonus screen graphics and some other small graphics. There has also been a much needed script revision.<br /><br />"
         },
	 {
            "label": "img",
            "value": [
	       {
                  "label": "0",
                  "value": <img src={ require('./img/proj/miracle2.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "1",
                  "value": <img src={ require('./img/proj/miracle3.png')} alt='' className='imageResize'/>
               },
	             ]
	 },
         {
            "label": "text",
            "value": "<br /><i>Miracle Girls is based on a manga by Nami Akimoto. It was later adapted into a TV anime series.  The manga is about twin sisters Tomomi and Mikage Matsunaga, and their love lives in high school. Tomomi is tomboyish and athletic, while Mikage is feminine and intellectual. These twins have ESP powers but they try to hide this from their friends. Only Mr. Kageura knows their secret!<br /><br />In the game, the sisters and their friends are suddenly teleported to a strange and magical world. You must help them find their missing friends and defeat Majo-Majo's villains by throwing candy as your only weapon, and eventually find the way back home.</i><br /><br />"
         },
	 {
            "label": "img",
            "value": [
               {
                  "label": "0",
                  "value": <img src={ require('./img/proj/miracle1.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "1",
                  "value": <img src={ require('./img/proj/miracle4.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "2",
                  "value": <img src={ require('./img/proj/miracle5.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "3",
                  "value": <img src={ require('./img/proj/miracle6.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "4",
                  "value": <img src={ require('./img/proj/miracle7.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "5",
                  "value": <img src={ require('./img/proj/miracle8.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "6",
                  "value": <img src={ require('./img/proj/miracle9.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "7",
                  "value": <img src={ require('./img/proj/miracle10.png')} alt='' className='imageResize'/>
               }
            ]
         },
      ]
   },
   "17": {
      "id": "17",
      "filter": "undercover",
      "date": "3 February 2019",
      "subtitle": "<b>Undercover Cops</b> v1.0 English Release<br />",
      "content": [
         {
            "label": "text",
            "value": "<b>Download Undercover Cops English Translation patch v1.0 ",
	},
	{
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <span><a href={ require('./files/Undercover Cops - English v1.0.zip')} download='Undercover Cops - English v1.0.zip'>HERE</a><br /></span>
               }
            ]
         },
	 {
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <Link to='undercover'>Undercover Cops project page</Link>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br /><br />This game does not have too much text, it's mostly for the intro and the endings.  There are 3 characters to play as, but if you choose Rosa and get the good ending, it also shows the lyrics for the song Tokimeki Street during the credits.<br /><br />I always liked the graphics of this game (made by developers of the Metal Slug series) and it features one of the weirdest bosses to fight against aka Fransowors.<br /><br /><i>It's 2043 and Dr. Crayborn and his gang have taken control of New York's streets. The city mayor has made one last plea for help and called three of the finest City Sweepers: Zan, an ex-karate master; Matt, an ex-professional football player and Rosa, the only female vigilante whose boyfriend was killed by villains. They must fight the gang and eliminate Dr. Crayborn in order to restore peace to the city.</i><br /><br />"
         },
	 {
            "label": "img",
            "value": [
               {
                  "label": "0",
                  "value": <img src={ require('./img/proj/undercover_00001.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "1",
                  "value": <img src={ require('./img/proj/undercover_00002.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "2",
                  "value": <img src={ require('./img/proj/undercover_00007.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "3",
                  "value": <img src={ require('./img/proj/undercover_00004.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "4",
                  "value": <img src={ require('./img/proj/undercover1.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "5",
                  "value": <img src={ require('./img/proj/undercover2.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "6",
                  "value": <img src={ require('./img/proj/undercover3.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "7",
                  "value": <img src={ require('./img/proj/undercover4.png')} alt='' className='imageResize'/>
               }
            ]
         },
	{
            "label": "text",
            "value": "<br /><i>Hint - To get the good ending, you need to attack Dr. Crayborn while he is dropping the bomb and make it stop.</i>"
         },
          {
            "label": "img",
            "value": [
               {
                  "label": "0",
                  "value": <img src={ require('./img/proj/undercover_00010.png')} alt='' className='imageResize'/>
               }
            ]
         },
      ]
   },
   "16": {
      "id": "16",
      "filter": "mickey3",
      "date": "26 November 2018",
      "subtitle": "<b>Magical Quest 3 starring Mickey & Donald</b> v1.2 English Release<br />",
      "content": [
         {
            "label": "text",
            "value": "<b>Download Magical Quest 3 English Translation patch v1.2 ",
	},
	{
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <span><a href={ require('./files/Magical Quest 3 - English v1.5.zip')} download='Magical Quest 3 - English v1.5.zip'>HERE</a><br /></span>
               }
            ]
         },
	 {
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <Link to='mickey3'>Magical Quest 3 project page</Link>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br /><br />This update adds some finishing touches to the previous version, most notably featuring a 2-line star effect on stage names, graphic updates and a script revision.  This is also the last of the old RPGONE translation updates.<br /><br />V1.2 Updates include:<br /><ul><li>Stage Name 2 line star effect</li><li>Updated English graphics</li><li>Script revision</li><li>Region protection removed</li><li>Startup screen graphic remade</li><br />"
         },
	 {
            "label": "img",
            "value": [
               {
                  "label": "0",
                  "value": <img src={ require('./img/proj/mickey3e_00000.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "1",
                  "value": <img src={ require('./img/proj/mickey3e_00007.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "2",
                  "value": <img src={ require('./img/proj/mickey3e_00008.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "3",
                  "value": <img src={ require('./img/proj/mickey3e_00034.png')} alt='' className='imageResize'/>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br />A <a href='https://traduccionessemco.blogspot.com/2018/12/traduccion-magical-quest-3-starring.html'> Spanish translation by Semco</a> has also recently been released.<br />"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": "0",
                  "value": <img src={ require('./img/proj/mickey_esp_3000.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "1",
                  "value": <img src={ require('./img/proj/mickey_esp_3001.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "2",
                  "value": <img src={ require('./img/proj/mickey_esp_3002.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "3",
                  "value": <img src={ require('./img/proj/mickey_esp_3004.png')} alt='' className='imageResize'/>
               }
            ]
         },
      ]
   },
   "15": {
      "id": "15",
      "filter": "doremi",
      "date": "20 November 2018",
      "subtitle": "<b>DoReMi Fantasy : Milon's Quest</b> v1.2 English, German and Spanish Release<br />",
      "content": [
         {
            "label": "text",
            "value": "<b>Download DoReMi Fantasy English Translation patch v1.1 ",
	},
	{
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <a href={ require('./files/Doremi Fantasy - English v1.1.zip')} download='Doremi Fantasy - English v1.1.zip'>HERE</a>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br /><b>Download DoReMi Fantasy English Translation patch v1.2 with New Ending ",
	},
        {
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <span><a href={ require('./files/Doremi Fantasy - English v1.3.zip')} download='Doremi Fantasy - English v1.3.zip'>HERE</a><br /></span>
               }
            ]
         },
         {
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <Link to='doremi'>DoReMi Fantasy project page</Link>
               }
            ]
         },
	 {
            "label": "img",
            "value": [
               {
                  "label": "0",
                  "value": <img src={ require('./img/doremi5.png')} alt='' className='imageResize'/>
               }
		     ]
	 },
         {
            "label": "text",
            "value": "<br />The main purpose of this update is to fix the minigame crashing issue from v1.0, which happened on real Snes, and also sometimes occured in some emulators.  This update has been tested and is working on bsnes, Snes9X v1.57, SNESMini and real Snes.<br />There was also an issue where the startup screen for English and German v1.0 was not displaying correctly on reset, relating to an issue with using DMA channel 0, which has also been fixed.<br />There are various graphic improvements in this update such as for world map names and minigames, and some new hacks added like for the dialogue cursor.<br /><br />V1.1 translation updates include:<br /><ul><li>Minigame crash issue fixed (Tested and working on real Snes)</li><li>Title screen options text expanded</li><li>Scrolling clouds added on the title screen</li><li>Dialogue selection cursor converted to 8X16 to match dialogue font</li><li>Title logo graphic updated</li><li>Various text graphics improved</li><li>Dialogue text improved</li><li>New startup screen</li><br />"
         },
	 {
            "label": "img",
            "value": [
               {
                  "label": "0",
                  "value": <img src={ require('./img/doremi1.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "1",
                  "value": <img src={ require('./img/doremi6.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "2",
                  "value": <img src={ require('./img/doremi3.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "3",
                  "value": <img src={ require('./img/doremi4.png')} alt='' className='imageResize'/>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br />Also <a href='https://www.romhacking.net/translations/1187/'>v1.2 German by Ghettoyouth</a> and <a href='https://www.romhacking.net/translations/3980/'>v1.2 Spanish by Crimental</a> versions have been released.<br />"
         },
	 {
            "label": "img",
            "value": [
               {
                  "label": "0",
                  "value": <img src={ require('./img/doremide1.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "1",
                  "value": <img src={ require('./img/doremi2.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "2",
                  "value": <img src={ require('./img/doremies1.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "3",
                  "value": <img src={ require('./img/proj/doremi_00188.png')} alt='' className='imageResize'/>
               }
            ]
         },
	 {
            "label": "text",
            "value": "<br />Thanks to Ghettoyouth and <a href='http://elbauldekarlanga.blogspot.com/2015/03/do-re-mi-fantasy-snes-espanol.html'>Crimental</a> for translating this game into their own languages. Thanks also go to <a href='https://traduccionessemco.blogspot.com/'>Semco</a> and <a href='https://www.youtube.com/user/haxxor199X'>vince94!</a><br /><br /><div class='center-image'><b>New Ending Sequence</b></div>Additionally, a new ending has been created for the English version.<br/>This game is quite well designed until beating the final boss Amon where it goes straight to the credits, by which time the player has likely forgotten what the main story was about. This is where it felt slightly unfinished.<br />A 6 scene ending sequence has now been programmed from scratch (using the original game music and sound effects). It will run after beating the final boss Amon and is also viewable as a selectable option from the title screen.<br />"
         },
	 {
            "label": "img",
            "value": [
               {
                  "label": "0",
                  "value": <img src={ require('./img/doremi_e1.gif')} alt='' className='imageResize'/>
               },
               {
                  "label": "1",
                  "value": <img src={ require('./img/doremi_e2.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "2",
                  "value": <img src={ require('./img/doremi_e3.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "3",
                  "value": <img src={ require('./img/doremi_e4.gif')} alt='' className='imageResize'/>
               }
            ]
         },
      ]
   },
   "14": {
      "id": "14",
      "filter": "koryu",
      "date": "31 July 2018",
      "subtitle": "<b>Koryu No Mimi</b> v2.0 English, Spanish and French Release<br />",
      "content": [
         {
            "label": "text",
            "value": "<b>Download Koryu No Mimi English Translation patch v2.0 ",
	},
	{
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <span><a href={ require('./files/Koryu No Mimi - English v2.0.zip')} download='Koryu No Mimi - English v2.0.zip'>HERE</a><br /></span>
               }
            ]
         },
         {
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <Link to='koryu'>Koryu No Mimi project page</Link>
               }
            ]
         },
	 {
            "label": "text",
            "value": "<br /><br />After many years and a lot of work, the final version of this translation is finally complete.<br />v2.0 Updates include:<br /><ul><li>Fully working on real SNES hardware (No slowdown anymore)</li><li>VWF code updated</li><li>Font has been improved and VWF widths adjusted</li><li>New Character name graphics</li><li>Script revision</li><li>Hi-Score displayed on title-screen</li></ul><br />Thanks go to ChrisRPG for updating his VWF code back in 2007 which helped make this release possible.<br />"
         },
	 {
            "label": "img",
            "value": [
               {
                  "label": "0",
                  "value": <img src={ require('./img/proj/koryu_00000.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "1",
                  "value": <img src={ require('./img/proj/koryu_00002.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "2",
                  "value": <img src={ require('./img/proj/koryu_00015.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "3",
                  "value": <img src={ require('./img/proj/koryu_00037.png')} alt='' className='imageResize'/>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br />Also v2.0 Spanish by <a href='https://traduccionessemco.blogspot.com/2018/06/traduccion-de-kouryuu-no-mimi-v-20-snes.html'>Semco</a> and v2.0 French by <a href='http://terminus.romhack.net/index.php?page=jv&projet=KouryuNoMimiFr'>FlashPV</a> versions were recently released.<br />"
         },
	 {
            "label": "img",
            "value": [
               {
                  "label": "0",
                  "value": <img src={ require('./img/koryu_es_00000.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "1",
                  "value": <img src={ require('./img/koryu_es_00001.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "2",
                  "value": <img src={ require('./img/koryu_fr_00000.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "3",
                  "value": <img src={ require('./img/koryu_fr_00001.png')} alt='' className='imageResize'/>
               }
            ]
         },
	 {
            "label": "text",
            "value": "<br />Thanks to Semco and FlashPV for translating this game into their own languages.<br /><br />Note this v2.0 update works on a real SNES, bsnes, no$sns, zsnes, etc but is not working on the latest v1.56 release of Snes9x. It works on Snes9x v1.43 and earlier.<br />"
         },
      ]
   },
   "13": {
      "id": "13",
      "filter": "site",
      "date": "10 January 2018",
      "subtitle": "New Hosting",
      "content": [
         {
            "label": "text",
            "value": "Thanks to Matthew Callis of <a href='http://superfamicom.org/'>superfamicom.org</a> for the new Hosting!"
	 },
      ]
   },
   "12": {
      "id": "12",
      "filter": "ace",
      "date": "31 December 2017",
      "subtitle": "<b>Aim for the Ace! (Ace Wo Nerae!)</b> v1.3 English Release<br />",
      "content": [
         {
            "label": "text",
            "value": "<b>Download Aim for the Ace! English Translation patch v1.3</b> "
	 },
	 {
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <span><a href={ require('./files/Aim for the Ace - English v1.3.zip')} download='Aim for the Ace - English v1.3.zip'>HERE</a><br /></span>
               }
            ]
         },
         {
            "label": "code",
            "value": [
               {
                  "label": "0",
                  "value": <Link to='ace'>Aim for the Ace! project page</Link>
               }
            ]
         },
         {
            "label": "text",
            "value": "</b><br /><br />This update includes converting the font from 8X8 to 8X16, new uppercase font added, script revision, various text screens have been expanded, new title logo, and the startup screen has been remade.<br /><br />"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": "0",
                  "value": <img src={ require('./img/proj/ace_00000.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "1",
                  "value": <img src={ require('./img/proj/ace_00001.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "2",
                  "value": <img src={ require('./img/proj/ace_00004.png')} alt='' className='imageResize'/>
               },
               {
                  "label": "3",
                  "value": <img src={ require('./img/proj/ace_00012.png')} alt='' className='imageResize'/>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br />Aiming to release updates for the other translations this coming year, as they are all just about finished, with Koryu No Mimi and Magical Quest 3 both currently in beta testing and DoReMi Fantasy has just 1 issue to work on.<br />"
         }
      ]
   },
   "11": {
      "id": "11",
      "filter": "mickey3",
      "date": "8 September 2017",
      "subtitle": "<b>Magical Quest 3 starring Mickey & Donald Update</b><br />",
      "content": [
         {
            "label": "text",
            "value": "The last updates for the Magical Quest 3 translation have now been completed.<br /><br /><div class='center-image'>A new <b>Title Logo</b> has been created and the <b>Bonus Stage graphics</b> have been improved.</span>"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/proj/mickey3e_00000.png')} alt='' className='imageResize'/>
               },
               {
                  "label": 1,
                  "value": <img src={ require('./img/mickey3e_00005_bonus.png')} alt='' className='imageResize'/>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br /><div class='center-image'>The <b>Script</b> has also been revised.</span>"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/mickey3e_00002.png')} alt='' className='imageResize'/>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br /><div class='center-image'>The <b>2 line star effect for Stage Names</b> has been finished<span>"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/Stage_name_2_line.gif')} alt='' className='imageResize'/>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br />The <b>startup screen graphic</b> featuring Mickey and Donald in their suits of armor has been remade. I redrew most of the lines for the SNES graphic after re-converting it from the source jpg image to make it look more like the original.<br /><div class='center-image'><b>Old Intro on left, New Intro on Right</b></div>"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/mickey3_00000Old.png')} alt='' className='imageResize'/>
               },
               {
                  "label": 1,
                  "value": <img src={ require('./img/mickey3e_00000_intro.png')} alt='' className='imageResize'/>
               }
            ]
         }
      ]
   },
   "10": {
      "id": "10",
      "filter": "koryu",
      "date": "29 August 2017",
      "subtitle": "<b>Koryu No Mimi</b> Update<br />",
      "content": [
         {
            "label": "text",
            "value": "The Developers created some <b>character portrait graphics</b> that can display on just the left side of the screen during ingame text sequences, even in cases where it did not match the character underneath or the text.<br /><br /><div class='center-image'>Who are Gordon and Kanako talking to here, in the old version?</div>"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/koryu_00029Before.png')} alt='' className='imageResize'/>
               },
               {
                  "label": 1,
                  "value": <img src={ require('./img/koryu_OriginalPortrait.png')} alt='' className='imageResize'/>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br />I've now created a total of 5 character portraits throughout the game to display on the right side of the screen and then show Kiroemon's portrait on the left side.  This required re-drawing the whole image in a tile editor to use a different palette and then manually transfering it for display.<br /><br />Before the game just showed,  for example Sinclaire Gordon's portrait apparently talking to no-one which wasn't consistent with the rest of the text sequences.<br /><br /><div class='center-image'><b>Below shows the new Character Portrait arrangements</b></div>"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/koryu_00002p.png')} alt='' className='imageResize'/>
               },
               {
                  "label": 1,
                  "value": <img src={ require('./img/koryu_00003p.png')} alt='' className='imageResize'/>
               },
               {
                  "label": 2,
                  "value": <img src={ require('./img/koryu_00000p.png')} alt='' className='imageResize'/>
               },
               {
                  "label": 3,
                  "value": <img src={ require('./img/koryu_00001p.png')} alt='' className='imageResize'/>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br />The <b>font</b> has been improved and the VWF font widths have been optimized for readability.<br /><div class='center-image'><b>Old version on left, and New on right</b></div>"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/koryu_font_before.png')} alt='' className='imageResize'/>
               },
               {
                  "label": 1,
                  "value": <img src={ require('./img/koryu_font_after.png')} alt='' className='imageResize'/>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br />The <b>character name</b> graphics have been remade and the space for name graphics in vram has been expanded to allow for longer names.<br /><div class='center-image'><b>Old v1.0 name left, Right the New v2.0 names</b></div>"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/koryu_name_00049.png')} alt='' className='imageResize'/>
               },
               {
                  "label": 1,
                  "value": <img src={ require('./img/koryu_name_00010.png')} alt='' className='imageResize'/>
               }
            ]
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/koryu_name_00010a.png')} alt='' className='imageResize'/>
               },
               {
                  "label": 1,
                  "value": <img src={ require('./img/koryu_name_00014.png')} alt='' className='imageResize'/>
               },
               {
                  "label": 2,
                  "value": <img src={ require('./img/koryu_name_00015.png')} alt='' className='imageResize'/>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br />The v2.0 Koryu No Mimi update seems complete now. It now just needs to be fully play-tested on a real SNES.<br />"
         }
      ]
   },
   "9": {
      "id": "9",
      "filter": "koryu",
      "date": "16 July 2017",
      "subtitle": "<b>Koryu No Mimi Update</b><br />",
      "content": [
         {
            "label": "text",
            "value": "The Intro text has been better formatted with more spacing between line breaks, which makes it much more readable than before where it was all 1 block.<br /><br />The last dialogue VWF code from ChrisRPG displays the dialogue text as a whole block at a time, rather than displaying 1 letter at a time as it used to do in v1.0 patch and the Japanese version, which makes it easy to go through the dialogue quickly.<br /><br /><div class='center-image'><b>Left is the Early version Without VWF, Right is the New version with VWF</b></div>"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/earlykoryu_novwf.png')} alt='' className='imageResize'/>
               },
               {
                  "label": 1,
                  "value": <img src={ require('./img/koryu_00003intro.png')} alt='' className='imageResize'/>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br />A feature added a while ago was to save the players score to SRAM and to display the previous score and Hi-Score on the title screen.  It will only appear if SRAM is enabled.<br />"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/koryu_00000_title_score.png')} alt='' className='imageResize'/>
               }
            ]
         }
      ]
   },
   "8": {
      "id": "8",
      "filter": "doremi",
      "date": "12 November 2016",
      "subtitle": "<b>DoReMi Fantasy Update</b><br />",
      "content": [
         {
            "label": "text",
            "value": "Recently been improving some of the English graphics. The 'Journey Forest' name was a bit squashed in, specifically the 's' was, and this graphic has now been updated.  As suggested by <a href='https://www.youtube.com/user/haxxor199X'>vince94</a>, the name has also been changed to 'Forest Journey'.<br /><div class='center-image'><b>Before and After</b></div>"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/doremi_00000_journey_forest_before.png')} alt='' className='imageResize'/>
               },
               {
                  "label": 1,
                  "value": <img src={ require('./img/doremi_00001_journey_forest_after.png')} alt='' className='imageResize'/>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br />The Title logo graphic has been touched up and the Subtitle graphic has been remade using a neater font.<br /><div class='center-image'><b>Before and After</b></div>"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/doremi_00000_title_10.png')} alt='' className='imageResize'/>
               },
               {
                  "label": 1,
                  "value": <img src={ require('./img/doremi00002_title.png')} alt='' className='imageResize'/>
               }
            ]
         }
      ]
   },
   "7": {
      "id": "7",
      "filter": "mickey3",
      "date": "20 October 2016",
      "subtitle": "<b>Magical Quest 3 starring Mickey & Donald</b> - The Nephew Colors Hack Release<br />",
      "content": [
 {
            "label": "text",
            "value": "The nephew colors won't be changed in the main translation, but a patch just to change the nephew colors has been released "
         },
	 {
            "label": "code",
            "value": [
               {
                  "label": 0,
                  "value": <a href={ require('./files/Magical Quest 3 - Nephew Colors hack.zip')} download='Magical Quest 3 - Nephew Colors hack.zip'>HERE</a>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br /><br /><br /><i>Disney archivist Dave Smith once said, <b>Note that the brightest hue of the three is red (Huey), the color of water, dew, is blue (Dewey), and that leaves Louie, and leaves are green.</b></i><br /><br />Some people say that the nephew colors are wrong in this game, so I decided to change them to their usual colors.<br /><br />Looking in Vram you can see the nephews all use the same sprites.<br /><div class='center-image'><b>First is Huey shown at end of stage 1. Second is Dewey shown at end of stage 2. (Graphics in tile editor)</b></div>"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/nephews1.png')} alt='' />
               },
               {
                  "label": 1,
                  "value": <img src={ require('./img/nephews2.png')} alt='' />
               }
            ]
         },
         {
            "label": "text",
            "value": "<br /><div class='center-image'><b>The 3 nephew palettes in bsnes palette viewer.</b></div>"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/nephewsPalette.png')} alt='' className='imageResize'/>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br />Searching for this palette data in the ROM gives a couple of matching results.<br /><br /><div class='center-image'><b>As a test the 3 nephew palettes were changed to blue in the ROM.</b></div>"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/mickey3e_00011.png')} alt='' className='imageResize'/>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br />Now we know they are the correct palettes.<br /><br />The palette has now been changed for Huey to his usual color. As you can see Huey was Blue, now his palette has been changed to Red.<br /><div class='center-image'><b>Before and After</b></div>"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/mickey3e_00012.png')} alt='' className='imageResize'/>
               },
               {
                  "label": 1,
                  "value": <img src={ require('./img/mickey3e_00010.png')} alt='' className='imageResize'/>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br /><div class='center-image'><b>The finished hack for the other nephews</b></div>"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/mickey3e_00002_nephew_colors_hack.png')} alt='' className='imageResize'/>
               },
               {
                  "label": 1,
                  "value": <img src={ require('./img/mickey3e_00003_nephew_colors_hack.png')} alt='' className='imageResize'/>
               }
            ]
         },
      ]
   },
   "6": {
      "id": "6",
      "filter": "doremi",
      "date": "22 September 2016",
      "subtitle": "<b>DoReMi Fantasy Dialogue option cursor</b><br />",
      "content": [
         {
            "label": "text",
            "value": "One of the remaining hacks was to convert the Dialogue option cursor from 8x8 font to 8X16, so that it would properly align with the dialogue font. <br /><br />The game originally used the 8x8 debug font for the dialogue cursor and in the English translation this meant that the cursor pointed to just below the text option! <br />Now it looks much better being aligned with the text.<br /><div class='center-image'><b>Before and After</b></div>"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/doremi_00146_cursor_before.png')} alt='' className='imageResize'/>
               },
               {
                  "label": 1,
                  "value": <img src={ require('./img/doremi_00047_cursor_after.png')} alt='' className='imageResize'/>
               }
            ]
         }
      ]
   },
   "5": {
      "id": "5",
      "filter": "koryu",
      "date": "20 September 2016",
      "subtitle": "<b>Koryu No Mimi</b> Update<br />",
      "content": [
         {
            "label": "text",
            "value": "I've spent the last few days fixing up the ingame text routine, to make when the text displays and when the character portraits display happen exactly at the same time.  Before it was off due to slowdown from VWF data transfer.<br />"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/koryu_00009.png')} alt='' className='imageResize'/>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br />When working on the ingame text, I found various codes, like <b>7e0500</b> allows you to play as other characters which are currently in Vram.<br />It means you can play as enemies like the Biker(7e050004), or bosses like Naomi(7e050005), or Souma(7e05000c), etc, just depending on what stage you are on which is really fun.<br /><br />The only lmitations are that they don't using the correct palette, and you can't see their weapons (but you can use their weapons).<br /><br />"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/koryu_00000.png')} alt='' className='imageResize'/>
               },
               {
                  "label": 1,
                  "value": <img src={ require('./img/koryu_00017.png')} alt='' className='imageResize'/>
               },
               {
                  "label": 2,
                  "value": <img src={ require('./img/koryu_00015.png')} alt='' className='imageResize'/>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br />"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/koryu_00020.png')} alt='' className='imageResize'/>
               },
               {
                  "label": 1,
                  "value": <img src={ require('./img/koryu_00028.png')} alt='' className='imageResize'/>
               },
               {
                  "label": 2,
                  "value": <img src={ require('./img/koryu_00012.png')} alt='' className='imageResize'/>
               }
            ]
         }
      ]
   },
   "4": {
      "id": "4",
      "filter": "doremi",
      "date": "14 September 2016",
      "subtitle": "<b>DoReMi Fantasy</b> Patch with Gaijin Productions is official<br />",
      "content": [
         {
            "label": "text",
            "value": "Musashi of Gaijin Productions who did the text translation for DoReMi Fantasy has agreed to let me officially put RPGONE's work together with theirs when the updated patch is released.<br /><br />The 2 patches are reliant on each other as there are some updates to their text translation. Now that means there is no need for multiple patches to play this game in English.<br /><br /><a href='http://web.archive.org/web/20031213191945/http://gaijin.parodius.com/Doremi.htm'>DoReMi Fantasy English Translation on Gaijin Productions Website (internet archive link)</a>"
         }
      ]
   },
   "3": {
      "id": "3",
      "filter": "koryu",
      "date": "10 September 2016",
      "subtitle": "<b>Koryu No Mimi</b> Update<br />",
      "content": [
         {
            "label": "text",
            "value": "Koryu No Mimi v1.0 was released back in 2004, and had a couple of issues, like a sprite overwrite bug (shown below) that occurred due to the location of credits text moved for the VWF.  This bug has now been fixed.<br />"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/koryubug.png')} alt='' className='imageResize'/>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br />The latest build of the translation has the Final version of the VWF finished by ChrisRPG in 2007.<br /><br />This update patch should have been finished and released in 2007, but it wasn't as there were a few issues still with Vblank in the VWF code which have now mostly been fixed.  This removes a lot of the slowdown which occurred when playing v1.0 of the translation.<br /><br />This updated translation has been tested and confirmed working on real SNES hardware again by <a href='http://superfamicom.org/'>Matthew Callis</a>."
         }
      ]
   },
   "2": {
      "id": "2",
      "filter": "doremi",
      "date": "5 September 2016",
      "subtitle": "<b>DoReMi Fantasy</b> Update<br />",
      "content": [
         {
            "label": "text",
            "value": "DoReMi Fantasy had an issue with the minigames not working on real SNES hardware.  This updated translation now has the minigame crash issue fixed.<br /><br />Scrolling clouds have also been added to the titlescreen.  In the Japanese version, the clouds do not move.<br /><br />The title screen menu text has also been expanded as can be seen below.<br /><div class='center-image'><b>Before and After</b></div>"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/doremi_00000.png')} alt='' className='imageResize'/>
               },
               {
                  "label": 1,
                  "value": <img src={ require('./img/doremi_titlescreen.gif')} alt='' className='imageResize'/>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br />This updated translation has been tested on a real SNES by <a href='http://superfamicom.org/'>Matthew Callis from superfamicom.org</a>."
         }
      ]
   },
   "1": {
      "id": "1",
      "filter": "mickey3",
      "date": "18 August 2016",
      "subtitle": "<b>Magical Quest 3 starring Mickey & Donald</b> Update<br />",
      "content": [
         {
            "label": "text",
            "value": "The main issue remaining is that the Japanese stage name was originally only 1 line and it was never properly converted to 2 lines in the translation.  The 2nd line just appeared with no star effect on it.<br /><br />Now it's been converted to properly use the 2nd line when necessary to display character by character. The star effect is now also mostly working for the 2nd line, it just needs a little more adjustment to be 100%.<br />"
         },
         {
            "label": "img",
            "value": [
               {
                  "label": 0,
                  "value": <img src={ require('./img/mickey3e_00013.png')} alt='' className='imageResize'/>
               },
               {
                  "label": 1,
                  "value": <img src={ require('./img/mickey3e_00016.png')} alt='' className='imageResize'/>
               }
            ]
         },
         {
            "label": "text",
            "value": "<br />I was shown a post on <a href='https://forums.nesdev.com/viewtopic.php?f=12&t=11675'>nesdev</a> where someone had an issue with the region protection lockout screen.<br /><br />I found that many years ago I had badly handled the branch for dealing with the region protection. I've updated the patch so it should now work on all SNES consoles.<br /><br />The protection code was quite basic:<pre>$80/FD08       LDA #$30<br />$80/FD0A       PHA<br />$80/FD0B       PLB<br />$80/FD0C       LDX #$1F00<br />$80/FD0F       LDA #$00<br />//Write a byte to SRAM<br />$80/FD11       STA $6000,x [$30:7F00]<br />//Check if byte was written to SRAM<br />$80/FD14       CMP $6000,x [$30:7F00]<br />//If there is no SRAM, go to $80FD33.<br />//#Changed to BRA to avoid protection<br />$80/FD17       <b>BNE $FD33</b><br />//Infinite loop if there is SRAM<br />//present, eg on copier device<br />$80/FD31       BRA $FD31<br />$80/FD33       SEP #$20<br /></pre>The other section of PAL region protection code:<br /><pre>//Load the destination country code<br />$80/FDD6       LDA $C0FFD9<br />//Game loads 00 & would branch here<br />$80/FDDA       BEQ $FDED<br />$80/FDDC       CMP #$01<br />$80/FDDE       BEQ $FDED<br />$80/FDE0       CMP #$0D<br />$80/FDE2       BEQ $FDED<br />$80/FDE4       LDA $213F<br />$80/FDE7       AND #$10<br />$80/FDE9       BEQ $FDF6<br />$80/FDEB       CLC<br />$80/FDEC       RTS<br />//Check if running on a PAL SNES<br />$80/FDED       LDA $213F<br />$80/FDF0       AND #$10<br />//Go to PAL Region Protection screen<br />//if on a PAL SNES.<br />//#Branch removed to avoid protection<br />$80/FDF2       <b>BNE $FDF6</b><br />$80/FDF4       CLC<br />$80/FDF5       RTS<br /></pre>"
         }
      ]
   }
};


export default updateData;


// WEBPACK FOOTER //
// ./src/updateData.js